import type CondicaoPagamento from "./CondicaoPagamento";
import type FormaPagamento from "./FormaPagamento";

export default class CondicaoPagamentoParcela {
    id: number | null;
    condicaoPagamento: Pick<CondicaoPagamento, "id" | "codigoInterno" | "descricao"> | null;
    sequencia: number;
    quantidadeParcelas: number;
    diasPrimeiroVencimento: number;
    diasEntreParcelas: number;
    diaFixoMes: number | null;
    formaPagamento: FormaPagamento | null;
    percentualRateio: number;

    constructor(
        id: number | null = null,
        condicaoPagamento: Pick<CondicaoPagamento, "id" | "codigoInterno" | "descricao"> | null = null,
        sequencia = 0,
        quantidadeParcelas = 1,
        diasPrimeiroVencimento = 0,
        diasEntreParcelas = 0,
        diaFixoMes: number | null = null,
        formaPagamento: FormaPagamento | null = null,
        percentualRateio = 100
    ) {
        this.id = id;
        this.condicaoPagamento = condicaoPagamento;
        this.sequencia = sequencia;
        this.quantidadeParcelas = quantidadeParcelas;
        this.diasPrimeiroVencimento = diasPrimeiroVencimento;
        this.diasEntreParcelas = diasEntreParcelas;
        this.diaFixoMes = diaFixoMes;
        this.formaPagamento = formaPagamento;
        this.percentualRateio = percentualRateio;
    }
}
